// Which client number opens which drill (fn_drill). EMPTY ON PURPOSE.
//
// The `what` / `id` / `scope` that mean Open, Blocked, Stalled, Waiting on client and
// Overdue for ONE client have not been confirmed against the backend,
// and a number that opens a broken sheet is worse than one that is plain text — the
// same call the Conversations rail made. Every number below is therefore rendered as
// plain text today. The whole path is built and tested: filling an entry in here is
// the only change needed to turn a number into a link.
//
//   { blocked: { what: 'bucket', id: 'blocked' } }   // id defaults to the client id
//
// Keys: overdue · blocked · stalled · needs_assistance · waiting_on_client · open · requests
export const CLIENT_DRILLS = {};

/**
 * The drill for one number on a client's page, or null when none is confirmed.
 * `scope.client_id` always carries the client so a drill never widens past it.
 *
 * @param {string} bucket
 * @param {string} clientId
 * @param {Record<string,{what:string,id?:string,scope?:object}>} [table]
 * @returns {{what:string,id:string,scope:object}|null}
 */
export const drillTargetFor = (bucket, clientId, table = CLIENT_DRILLS) => {
  const entry = Object.prototype.hasOwnProperty.call(table, bucket) ? table[bucket] : null;
  if (!entry || !entry.what || !clientId) return null;
  return { what: entry.what, id: entry.id ?? clientId, scope: { ...(entry.scope || {}), client_id: clientId } };
};
